import { KalTabComponent } from './kal-tab/kal-tab.component';

export class KalTabChange {
  constructor(public tab: KalTabComponent, public value: any) {
  }
}
